export enum EmissionFactorSourceEnum {
  EFDB = "EFDB",
  EXTERNAL = "EXTERNAL",
  EMISSION_FACTOR_SEARCH = "EMISSION_FACTOR_SEARCH",
  CUSTOMER_EF = "CUSTOMER_EF",
}

export enum TransportType {
  DISPOSAL = "DISPOSAL",
  PRE_CARRIAGE_INBOUND_LOGISTICS = "PRE_CARRIAGE_INBOUND_LOGISTICS",
  MAIN_CARRIAGE_INBOUND_LOGISTICS = "MAIN_CARRIAGE_INBOUND_LOGISTICS",
  POST_CARRIAGE_INBOUND_LOGISTICS = "POST_CARRIAGE_INBOUND_LOGISTICS",
}

export enum CoolingType {
  DISTRICT_COOLING = "District Cooling",
}

export enum HeatingType {
  DISTRICT_HEATING = "District Heating",
  STANDARD_HEATING = "Standard Heating",
}

export enum WaterType {
  DRINKING_WATER = "Drinking Water",
  DEIONISED_WATER = "Deionised Water",
}

export enum EmissionsGenerationType {
  PURCHASED = "PURCHASED",
  SELF_GENERATED = "SELF_GENERATED",
}

export enum HeatingAcquisitionType {
  PURCHASED = "PURCHASED",
  SELF_GENERATED = "SELF_GENERATED",
}

export enum LogisticsErrorType {
  NO_ROUTE_FOUND = "NO_ROUTE_FOUND",
  GENERIC_ERROR = "GENERIC_ERROR",
  ZIP_CODE_NOT_FOUND = "ZIP_CODE_NOT_FOUND",
  CITY_NOT_FOUND = "CITY_NOT_FOUND",
  POST_TRANSPORTATION_LOCATION_AIRPORT_REQUIRED = "POST_TRANSPORTATION_LOCATION_REQUIRED",
  PRE_AND_POST_TRANSPORTATION_LOCATIONS_AIRPORTS_REQUIRED = "PRE_AND_POST_TRANSPORTATION_LOCATIONS_REQUIRED",
  SAME_COUNTRY_NO_LOCATION = "SAME_COUNTRY_NO_LOCATION",
}

export enum LogisticsLocationSection {
  ORIGIN = "origin",
  DESTINATION = "destination",
  PRE_TRANSPORT = "pre_transport",
  POST_TRANSPORT = "post_transport",
}

export enum RefrigerantEmissionScenario {
  RefillQuantity = "REFILL_QUANTITY",
  SystemCapacity = "SYSTEM_CAPACITY",
  OfficeSpace = "OFFICE_SPACE",
}

export enum ElectricityGenerationType {
  PURCHASED = "PURCHASED",
  SELF_GENERATED = "SELF_GENERATED",
}

export enum RenewableFuelType {
  FUEL_BASED = "FUEL_BASED",
  NON_FUEL_BASED = "NON_FUEL_BASED",
}

export enum ExternalDataCenterElectricityEmissionScenario {
  ELECTRICITY_CONSUMED = "ELECTRICITY_CONSUMED",
  DATA_CONSUMED = "DATA_CONSUMED",
  PURCHASED = "PURCHASED",
  NON_FUEL_BASED = "NON_FUEL_BASED",
  FUEL_BASED = "FUEL_BASED",
  SELF_GENERATED = "SELF_GENERATED",
}

export enum CalculationState {
  InDataCollection = "InDataCollection",
  InReview = "InReview",
  Completed = "Completed",
  CompletedWithoutReview = "CompletedWithoutReview",
}

export enum FlightDistanceType {
  INTERCONTINENTAL = "INTERCONTINENTAL",
  CONTINENTAL = "CONTINENTAL",
}

export enum HotelStaysEmissionFactorStars {
  FIVE = "five",
  FOUR = "four",
  THREE = "three",
  TWO_OR_LESS = "twoOrLess",
  UNKNOWN = "unknown",
}

export enum LocationSearchType {
  AIRPORT = "airport",
  OTHER = "other",
}

export enum LogisticsMeansOfTransport {
  ROAD = "road",
  RAIL = "rail",
  AIR = "air",
  SEA = "sea",
  INLAND_WATERWAYS = "inlandWaterways",
  //The string values for truck represents the lorryClass inside ecotransit
  TRUCK_LESS_THAN_3_5T = "Class3_5",
  TRUCK_MORE_THAN_3_5T_AND_LESS_THAN_OR_EQUAL_7_5T = "Class7_5",
  TRUCK_MORE_THAN_7_5T_AND_LESS_THAN_OR_EQUAL_12T = "Class12",
  TRUCK_MORE_THAN_12T_AND_LESS_THAN_OR_EQUAL_20T = "Class20",
  TRUCK_MORE_THAN_20T_AND_LESS_THAN_OR_EQUAL_26T = "Class26",
  TRUCK_MORE_THAN_26T_AND_LESS_THAN_OR_EQUAL_40T = "Class40",
  TRUCK_MORE_THAN_40T_AND_LESS_THAN_OR_EQUAL_50T = "Class50",
  TRUCK_MORE_THAN_50T_AND_LESS_THAN_OR_EQUAL_60T = "Class60",
  TRUCK_MORE_THAN_60T = "ClassGt60",
}

export enum LogisticsIncoterms {
  EXW = "EXW",
  FCA = "FCA",
  FAS = "FAS",
  FOB = "FOB",
  CFR = "CFR",
  CIF = "CIF",
  CPT = "CPT",
  CIP = "CIP",
  DAP = "DAP",
  DPU = "DPU", // formerly DAT (Delivered at Terminal)
  DDP = "DDP",
}

export enum LogisticsScenario {
  FUEL = "FUEL",
  DISTANCE_WITH_ADDRESS_MATCHING = "DISTANCE_WITH_ADDRESS_MATCHING",
  DISTANCE_WITH_SPECIFIC_LOCATION = "DISTANCE_WITH_SPECIFIC_LOCATION",
}

export enum ReferencePeriod {
  MONTHLY = "monthly",
  WEEKLY = "weekly",
  ONE_TIME = "one-time",
}

export enum FoodCategory {
  FISH_BASED_COOKED = "fishBasedCooked",
  FISH_BASED_PURCHASED = "fishBasedPurchased",
  FISH_BASED_ORGANIC_COOKED = "fishBasedOrganicCooked",
  FISH_BASED_ORGANIC_PURCHASED = "fishBasedOrganicPurchased",
  MEAT_BASED_COOKED = "meatBasedCooked",
  MEAT_BASED_PURCHASED = "meatBasedPurchased",
  MEAT_BASED_ORGANIC_COOKED = "meatBasedOrganicCooked",
  MEAT_BASED_ORGANIC_PURCHASED = "meatBasedOrganicPurchased",
  VEGAN_COOKED = "veganCooked",
  VEGAN_PURCHASED = "veganPurchased",
  VEGAN_ORGANIC_COOKED = "veganOrganicCooked",
  VEGAN_ORGANIC_PURCHASED = "veganOrganicPurchased",
  VEGETARIAN_COOKED = "vegetarianCooked",
  VEGETARIAN_PURCHASED = "vegetarianPurchased",
  VEGETARIAN_ORGANIC_COOKED = "vegetarianOrganicCooked",
  VEGETARIAN_ORGANIC_PURCHASED = "vegetarianOrganicPurchased",
  MIXED_COOKED = "mixedCooked",
  MIXED_PURCHASED = "mixedPurchased",
  MIXED_ORGANIC_COOKED = "mixedOrganicCooked",
  MIXED_ORGANIC_PURCHASED = "mixedOrganicPurchased",
}

export enum FoodOrBeverageSelector {
  FOOD = "food",
  BEVERAGE = "beverage",
}

export enum MealPreparationType {
  COOKED = "cooked",
  PURCHASED = "purchased",
}

export enum FoodProductionType {
  ORGANIC = "organic",
  NON_ORGANIC = "nonOrganic",
}

export enum DietType {
  VEGAN = "vegan",
  VEGETARIAN = "vegetarian",
  MIXED = "mixed",
  MEAT_BASED = "meatBased",
  FISH_BASED = "fishBased",
}

export enum DefaultValuesType {
  REFRIGERANT_USE = "REFRIGERANT_USE",
  REFRIGERANT_LEAKAGE = "REFRIGERANT_LEAKAGE",
  FLIGHT_DETOUR_DISTANCE = "FLIGHT_DETOUR_DISTANCE",
  FLIGHT_DISTANCE_INTERCONTINENTAL = "FLIGHT_DISTANCE_INTERCONTINENTAL",
  FLIGHT_DISTANCE_CONTINENTAL = "FLIGHT_DISTANCE_CONTINENTAL",
  FLIGHT_HAUL_THRESHOLD = "FLIGHT_HAUL_THRESHOLD",
  ELECTRICITY_PER_GB = "ELECTRICITY_PER_GB",
  AVERAGE_YEARLY_WORK_DAYS_ASIA = "AVERAGE_YEARLY_WORK_DAYS_ASIA",
  AVERAGE_YEARLY_WORK_DAYS_EUROPE = "AVERAGE_YEARLY_WORK_DAYS_EUROPE",
  AVERAGE_YEARLY_WORK_DAYS_NORTH_AMERICA = "AVERAGE_YEARLY_WORK_DAYS_NORTH_AMERICA",
  AVERAGE_YEARLY_WORK_DAYS_OCEANIA = "AVERAGE_YEARLY_WORK_DAYS_OCEANIA",
  AVERAGE_YEARLY_WORK_DAYS_LATIN_AMERICA = "AVERAGE_YEARLY_WORK_DAYS_LATIN_AMERICA",
  AVERAGE_YEARLY_WORK_DAYS_AFRICA = "AVERAGE_YEARLY_WORK_DAYS_AFRICA",
  AVERAGE_YEARLY_WORK_DAYS_GLOBAL = "AVERAGE_YEARLY_WORK_DAYS_GLOBAL",
}

export enum SolutionType {
  CCF_BASIC = "ccf-basic",
  CCF_ENTERPRISE = "ccf-enterprise",
  CCF_ASSESSMENT = "ccf-assessment",
  CCF_CUSTOM = "ccf-custom",
  CCF_EMPLOYEE_COMMUTING = "ccf-employee-commuting",
  PCF = "pcf",
}

export enum CalculationType {
  CCF = "CCF",
  PCF = "PCF",
}

export enum EmissionSourceType {
  // Scope 1&2
  ELECTRICITY = "Electricity",
  HEATING_AND_FUEL = "Heating",
  COOLING = "Cooling",
  DIRECT_COMBUSTION = "DirectCombustion",
  DIRECT_FUGITIVE = "DirectFugitive",
  VEHICLE_FLEET = "VehicleFleet",
  // Scope 3
  // Purchased Goods And Services
  PRODUCTION_MATERIALS = "ProductionMaterials",
  PACKAGING = "Packaging",
  PURCHASED_SERVICE = "PurchasedService",
  OPERATING_SUPPLIES = "OperatingSupplies",
  FOOD_AND_BEVERAGES = "FoodAndDrinks",
  EXTERNAL_DATA_CENTER = "ExternalDataCenter",
  WATER = "Water",
  // Capital Goods
  CAPITAL_GOODS = "CapitalGoods",
  // Waste Generated In Operations
  DISPOSAL = "Disposal",
  // Business Travel
  PRIVATE_AND_RENTAL_VEHICLE = "PrivateAndRentalVehicle",
  RAIL_TRAVEL = "RailTravel",
  FLIGHT = "Flight",
  HOTEL_STAYS = "HotelStays",
  // Employee Commuting
  EMPLOYEE_COMMUTING = "EmployeeCommuting",
  // Upstream Leased Assets
  UPSTREAM_LEASED_ASSETS_ELECTRICITY = "UpstreamLeasedAssetsElectricity",
  UPSTREAM_LEASED_ASSETS_COMBUSTION = "UpstreamLeasedAssetsCombustion",
  UPSTREAM_LEASED_ASSETS_COOLING = "UpstreamLeasedAssetsCooling",
  UPSTREAM_LEASED_ASSETS_FUGITIVE = "UpstreamLeasedAssetsFugitive",
  // Transportation And Distribution
  INBOUND_LOGISTICS = "InboundLogistics",
  INTRALOGISTICS = "Intralogistics",
  OUTBOUND_LOGISTICS = "OutboundLogistics",
  STORAGE_UPSTREAM = "StorageUpstream",
  STORAGE_DOWNSTREAM = "StorageDownstream",
  // Processing Of Sold Products
  PROCESSING_OF_SOLD_PRODUCTS_ELECTRICITY = "ProcessingOfSoldProductsElectricity",
  PROCESSING_OF_SOLD_PRODUCTS_COMBUSTION = "ProcessingOfSoldProductsCombustion",
  PROCESSING_OF_SOLD_PRODUCTS_COOLING = "ProcessingOfSoldProductsCooling",
  PROCESSING_OF_SOLD_PRODUCTS_FUGITIVE = "ProcessingOfSoldProductsFugitive",
  PROCESSING_OF_SOLD_PRODUCTS_WASTE = "ProcessingOfSoldProductsWaste",
  // Use Of Sold Products
  USE_OF_SOLD_PRODUCTS_ELECTRICITY = "UseOfSoldProductsElectricity",
  USE_OF_SOLD_PRODUCTS_COMBUSTION = "UseOfSoldProductsCombustion",
  USE_OF_SOLD_PRODUCTS_COOLING = "UseOfSoldProductsCooling",
  USE_OF_SOLD_PRODUCTS_FUGITIVE = "UseOfSoldProductsFugitive",
  USE_OF_SOLD_PRODUCTS_OTHER = "UseOfSoldProductsOther",
  // End Of Life Treatment Of Sold Products
  PRODUCT_DISPOSAL = "ProductDisposal",
  // Downstream Leased Assets
  DOWNSTREAM_LEASED_ASSETS_ELECTRICITY = "DownstreamLeasedAssetsElectricity",
  DOWNSTREAM_LEASED_ASSETS_COMBUSTION = "DownstreamLeasedAssetsCombustion",
  DOWNSTREAM_LEASED_ASSETS_COOLING = "DownstreamLeasedAssetsCooling",
  DOWNSTREAM_LEASED_ASSETS_FUGITIVE = "DownstreamLeasedAssetsFugitive",
  // Franchises
  FRANCHISE = "Franchise",
  // Investments
  INVESTMENT = "Investment",
}

export enum Scope3Category {
  PURCHASED_GOODS_AND_SERVICES = "purchasedGoodsAndServices",
  CAPITAL_GOODS = "capitalGoods",
  WASTE_GENERATED_IN_OPERATIONS = "wasteGeneratedInOperations",
  BUSINESS_TRAVEL = "businessTravel",
  EMPLOYEE_COMMUTING = "employeeCommuting",
  UPSTREAM_LEASED_ASSETS = "upstreamLeasedAssets",
  DOWNSTREAM_LEASED_ASSETS = "downstreamLeasedAssets",
  FRANCHISES = "franchise",
  INVESTMENTS = "investment",
  TRANSPORTATION_AND_DISTRIBUTION = "transportationAndDistribution",
  PROCESSING_OF_SOLD_PRODUCTS = "processingOfSoldProducts",
  USE_OF_SOLD_PRODUCTS = "useOfSoldProducts",
  END_OF_LIFE_TREATMENT_OF_SOLD_PRODUCTS = "endOfLifeTreatmentOfSoldProducts",
}

export enum OperationType {
  LOGISTICS = "Logistics",
}

export enum SubCategorySlug {
  REFRIGERANT_LEAKAGE = "RefrigerantLeakage",
  HEAT_SELF_GENERATED = "HeatSelfGenerated",
  VEHICLE_FLEET = "VehicleFleet",
  COMBUSTION = "Combustion",
  FUGITIVE_EMISSIONS = "FugitiveEmissions",
  ELECTRICITY_STATIONARY = "ElectricityStationary",
  ELECTRICITY_VEHICLE_FLEET = "ElectricityVehicleFleet",
  PURCHASED_COOLING = "PurchasedCooling",
  PURCHASED_HEATING = "PurchasedHeating",
  PRODUCTION_MATERIALS = "ProductionMaterials",
  PACKAGING = "Packaging",
  PURCHASED_SERVICES = "PurchasedServices",
  OPERATIONAL_SUPPLIES = "OperationalSupplies",
  FOOD_AND_BEVERAGES = "FoodAndBeverages",
  EXTERNAL_DATA_CENTER = "ExternalDataCenter",
  WATER = "Water",
  CAPITAL_GOODS = "CapitalGoods",
  UPSTREAM_EMISSIONS_ELECTRICITY = "UpstreamEmissionsElectricity",
  UPSTREAM_EMISSIONS_HEATING = "UpstreamEmissionsHeating",
  UPSTREAM_EMISSIONS_COOLING = "UpstreamEmissionsCooling",
  UPSTREAM_EMISSIONS_VEHICLE_FLEET = "UpstreamEmissionsVehicleFleet",
  UPSTREAM_EMISSIONS_COMBUSTION = "UpstreamEmissionsCombustion",
  INBOUND_LOGISTICS = "InboundLogistics",
  INTRALOGISTICS = "Intralogistics",
  OUTBOUND_LOGISTICS_UPSTREAM = "OutboundLogisticsUpstream",
  STORAGE_UPSTREAM = "StorageUpstream",
  OPERATIONAL_WASTE = "OperationalWaste",
  TRANSPORT_TO_DISPOSAL_FACILITY = "TransportToDisposalFacility",
  PRIVATE_AND_RENTAL_VEHICLES = "PrivateAndRentalVehicles",
  RAIL = "Rail",
  FLIGHTS = "Flights",
  HOTEL_NIGHTS = "HotelNights",
  EMPLOYEE_COMMUTING = "EmployeeCommuting",
  HOME_OFFICE = "HomeOffice",
  UPSTREAM_LEASED_ASSETS_ELECTRICITY = "UpstreamLeasedAssetsElectricity",
  UPSTREAM_LEASED_ASSETS_COMBUSTION = "UpstreamLeasedAssetsCombustion",
  UPSTREAM_LEASED_ASSETS_COOLING = "UpstreamLeasedAssetsCooling",
  UPSTREAM_LEASED_ASSETS_FUGITIVE = "UpstreamLeasedAssetsFugitive",
  OUTBOUND_LOGISTICS_DOWNSTREAM = "OutboundLogisticsDownstream",
  STORAGE_DOWNSTREAM = "StorageDownstream",
  PROCESSING_OF_SOLD_PRODUCTS_ELECTRICITY = "ProcessingOfSoldProductsElectricity",
  PROCESSING_OF_SOLD_PRODUCTS_COMBUSTION = "ProcessingOfSoldProductsCombustion",
  PROCESSING_OF_SOLD_PRODUCTS_REFRIGERANT = "ProcessingOfSoldProductsRefrigerant",
  PROCESSING_OF_SOLD_PRODUCTS_FUGITIVE = "ProcessingOfSoldProductsFugitive",
  PROCESSING_OF_SOLD_PRODUCTS_WASTE = "ProcessingOfSoldProductsWaste",
  USE_OF_SOLD_PRODUCTS_ELECTRICITY = "UseOfSoldProductsElectricity",
  USE_OF_SOLD_PRODUCTS_COMBUSTION = "UseOfSoldProductsCombustion",
  USE_OF_SOLD_PRODUCTS_REFRIGERANT = "UseOfSoldProductsRefrigerant",
  USE_OF_SOLD_PRODUCTS_FUGITIVE = "UseOfSoldProductsFugitive",
  USE_OF_SOLD_PRODUCTS_OTHER = "UseOfSoldProductsOther",
  PRODUCT_DISPOSAL = "ProductDisposal",
  DOWNSTREAM_LEASED_ASSETS_ELECTRICITY = "DownstreamLeasedAssetsElectricity",
  DOWNSTREAM_LEASED_ASSETS_COMBUSTION = "DownstreamLeasedAssetsCombustion",
  DOWNSTREAM_LEASED_ASSETS_COOLING = "DownstreamLeasedAssetsCooling",
  DOWNSTREAM_LEASED_ASSETS_FUGITIVE = "DownstreamLeasedAssetsFugitive",
  FRANCHISES = "Franchises",
  INVESTMENTS = "Investments",
}

export enum NonRecyclingDisposalType {
  LANDFILL = "landfill",
  INCINERATION = "incineration",
  AVERAGE_DISPOSAL = "averageDisposal",
}

export enum RecyclingDisposalType {
  RECYCLING = "recycling",
}

export enum TernaryBoolean {
  TRUE = "true",
  FALSE = "false",
  UNKNOWN = "unknown",
}

export type DisposalType = NonRecyclingDisposalType | RecyclingDisposalType;

export type Scope3CoolingEmissionSourceType =
  | EmissionSourceType.UPSTREAM_LEASED_ASSETS_COOLING
  | EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_COOLING
  | EmissionSourceType.USE_OF_SOLD_PRODUCTS_COOLING
  | EmissionSourceType.DOWNSTREAM_LEASED_ASSETS_COOLING;

export type Scope3ElectricityEmissionSourceType =
  | EmissionSourceType.UPSTREAM_LEASED_ASSETS_ELECTRICITY
  | EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_ELECTRICITY
  | EmissionSourceType.USE_OF_SOLD_PRODUCTS_ELECTRICITY
  | EmissionSourceType.DOWNSTREAM_LEASED_ASSETS_ELECTRICITY;

export type Scope3CombustionEmissionSourceType =
  | EmissionSourceType.UPSTREAM_LEASED_ASSETS_COMBUSTION
  | EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_COMBUSTION
  | EmissionSourceType.USE_OF_SOLD_PRODUCTS_COMBUSTION
  | EmissionSourceType.DOWNSTREAM_LEASED_ASSETS_COMBUSTION;

export type Scope3FugitiveEmissionSourceType =
  | EmissionSourceType.UPSTREAM_LEASED_ASSETS_FUGITIVE
  | EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_FUGITIVE
  | EmissionSourceType.USE_OF_SOLD_PRODUCTS_FUGITIVE
  | EmissionSourceType.DOWNSTREAM_LEASED_ASSETS_FUGITIVE;

export type WasteEmissionType =
  | EmissionSourceType.PRODUCT_DISPOSAL
  | EmissionSourceType.DISPOSAL
  | EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_WASTE;

export type ExternallyCalculatedEmissionSourceType =
  | EmissionSourceType.DISPOSAL
  | EmissionSourceType.OPERATING_SUPPLIES
  | EmissionSourceType.FOOD_AND_BEVERAGES
  | EmissionSourceType.EXTERNAL_DATA_CENTER
  | EmissionSourceType.WATER
  | EmissionSourceType.PACKAGING
  | EmissionSourceType.PURCHASED_SERVICE
  | EmissionSourceType.CAPITAL_GOODS
  | EmissionSourceType.PRODUCTION_MATERIALS
  | EmissionSourceType.FRANCHISE
  | EmissionSourceType.INVESTMENT
  | EmissionSourceType.STORAGE_UPSTREAM
  | EmissionSourceType.STORAGE_DOWNSTREAM
  | EmissionSourceType.USE_OF_SOLD_PRODUCTS_OTHER;

export enum ContractualInstrumentContractType {
  BUNDLED = "BUNDLED",
  UNBUNDLED = "UNBUNDLED",
}

export enum ContractualInstrumentRenewableElectricitySourceType {
  RET = "RET",
  GOs = "GOs",
  RECs = "RECs",
  PPAs = "PPAs",
  EACs = "EACs",
  REGOs = "REGOs",
  I_RECs = "I_RECs",
  LGCs = "LGCs",
  NFCs = "NFCs",
  T_RECs = "T_RECs",
  TIGRs = "TIGRs",
  GECs = "GECs",
  OTHER = "OTHER",
}

export enum ContractualInstrumentRenewableHeatingSourceType {
  HPA = "HPA",
  RHPA = "RHPA",
  OTHER = "OTHER",
}

export enum VehicleFleetFuelType {
  CNG = "CNG",
  ELECTRICITY = "ELECTRICITY",
  LPG = "LPG",
  MINERAL_DIESEL = "MINERAL_DIESEL",
  MINERAL_PETROL = "MINERAL_PETROL",
  B7 = "B7",
  E10 = "E10",
}

export enum ReportType {
  CSRD = "CSRD",
  CLIMATE_PARTNER = "ClimatePartner",
  SBTI = "SBTi",
  PCF_REPORT = "PCFReport",
  PCF_CERTIFICATE = "PCFCertificate",
  PCF_CRADLE_TO_GRAVE = "PCFCradleToGrave",
  REDUCTION_PLAN = "ReductionPlan",
}

export enum DataQuality {
  VERY_HIGH = 1,
  HIGH = 2,
  MEDIUM = 3,
  LOW = 4,
  VERY_LOW = 5,
  UNKNOWN = "unknown",
}

export enum AssumptionType {
  DEFAULT_VALUE = "DEFAULT_VALUE",
  LOGISTICS_CAPITAL_CITY = "LOGISTICS_CAPITAL_CITY",
}

export enum TransportationModeSpecifics {
  REFRIGERATED = "refrigerated",
  NONE = "none",
}

export enum SystemBoundaries {
  CRADLE_TO_GRAVE = "cradle_to_grave",
  CRADLE_TO_GATE = "cradle_to_gate",
}

export enum EmissionsFactorMetadataVariant {
  DIRECT = "directEmissionFactorMetadata",
  INDIRECT = "indirectEmissionFactorMetadata",
}

export enum CalculationFactorPlaceholderName {
  EFDB = "EFDB ID Provided",
  EXTERNAL_EF = "External EF Provided",
  EXTERNALLY_CALCULATED = "Externally Calculated",
  CUSTOMER_EF = "Customer EF Library",
}

export enum SuppliedDataEntryType {
  PACKAGING = "packaging",
  RAW_MATERIAL = "raw_material",
}

export enum MaterialEnrichmentErrorCode {
  EF_NOT_FOUND = "EF_NOT_FOUND",
  EF_UNIT_MISMATCH = "EF_UNIT_MISMATCH",
  EF_CONVERSION_MISSING = "EF_CONVERSION_MISSING",
  EFDB_ID_NOT_FOUND = "EFDB_ID_NOT_FOUND",
}

export enum MatchingCandidateSource {
  ECOPILOT = "ecopilot",
  HISTORIC = "historic",
  SEMANTIC = "semantic",
  EF_LIBRARY = "ef-library",
}

export enum MatchingCandidateEfType {
  EFDB_EF = "efdb-ef",
  CUSTOMER_EF = "customer-ef",
  SUPPLIER_SPECIFIC_GWP = "supplier-specific-gwp",
  EXTERNALLY_CREATED_EF = "externally-created-ef",
}

export enum PcfSourceType {
  REPORT_DRAFT = "REPORT_DRAFT",
  CALCULATION = "CALCULATION",
}
export enum DraftEntryPoint {
  PCF_LIBRARY_PAGE = "PCF_LIBRARY_PAGE",
  EMISSION_FACTOR_LIBRARY = "EMISSION_FACTOR_LIBRARY",
  MY_NETWORK = "MY_NETWORK",
  PCF_LIBRARY = "PCF_LIBRARY",
}

export enum DraftStatus {
  UPLOADED = "UPLOADED",
  EXTRACTING = "EXTRACTING",
  EXTRACTED = "EXTRACTED",
  FAILED = "FAILED",
  REVIEWED = "REVIEWED",
  CHECKED = "CHECKED",
  ASSIGNED = "ASSIGNED",
}

export enum CheckCategory {
  SCHEMA = "SCHEMA",
  METHODOLOGY = "METHODOLOGY",
  INTERNAL_LOGIC = "INTERNAL_LOGIC",
  SCOPE = "SCOPE",
}

export enum CheckStatus {
  PASS = "PASS",
  WARN = "WARN",
  FAIL = "FAIL",
}

export enum CheckVerdict {
  PASS = "PASS",
  ACCEPTABLE = "ACCEPTABLE",
  FAIL = "FAIL",
}
